import * as angular from 'angular';
import * as moment from 'moment';
import { IFrequency } from '../../models';
import { toDuration } from './toDuration';

const formats: { [unit: number]: string } = {
    0: 's',
    1: 'min',
    2: 'h',
    3: 'd',
    4: 'w',
    5: 'M',
    6: 'y'
};

export interface IFrequencyFormatHelperService {
    formatFrequency(frequency: IFrequency): string;
    toDuration(freq: IFrequency): moment.Duration;
}

export class FrequencyFormatHelperService implements IFrequencyFormatHelperService {

    static serviceId = 'frequencyFormatHelperService';
    static $inject = ['$translate'];

    constructor(private _$translate: angular.translate.ITranslateService) {
    }

    formatFrequency(frequency: IFrequency): string {
        // let unit = TimeUnit[frequency.intervalTimeUnit] + (frequency.interval > 1 ? 's' : '');
        let unit = formats[frequency.intervalTimeUnit];
        unit = this._$translate.instant(unit);
        return frequency.interval + ' ' + unit;
    }

    toDuration(freq: IFrequency): moment.Duration {
        return toDuration(freq);
    }
}